<template>
    <div>
      Hello world
    </div>
</template>

<script>
  export default {
    name: 'home'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// home.vue?cb283dbc